// extracted by mini-css-extract-plugin
export default {"app":"styles_app__KscJ-"};